import { Pipe, PipeTransform } from '@angular/core'
import { ButtonType } from '@tv3/shared/button/button.component'

@Pipe({
  name: 'buttonClass',
})
export class ButtonClassPipe implements PipeTransform {
  transform(type: ButtonType): string {
    switch (type) {
      case 'success':
        return 'btn text-uppercase btn-success'
      case 'warning':
        return 'btn text-uppercase btn-cst-warning'
      case 'info':
        return 'btn text-uppercase btn-cst-info'
      case 'danger':
        return 'btn text-uppercase btn-danger'
    }
  }
}
